<script>
  import { onMount } from 'svelte'
  // import { slide } from 'svelte/transition'
  // import { cubicOut } from 'svelte/easing'

  export let messages

  let mappedMessages = messages.map((text, i) => ({ text, visible: i < 2, animating: i !== 0 }))

  onMount(async () => {
    const prefersReducedMotion =
      !document.body.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (prefersReducedMotion) {
      mappedMessages = mappedMessages.map((el) => ({ ...el, visible: true, animating: false }))
    } else if (mappedMessages.length > 1) {
      await sleep(1900)
      mappedMessages[1].animating = false
      // await sleep(1200)
      // mappedMessages[2].visible = true
      // await sleep(2200)
      // mappedMessages[2].animating = false
    }
  })

  async function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  // function fadeSlide(node, options) {
  //   const slideTrans = slide(node, options)
  //   return {
  //     duration: options.duration,
  //     css: (t) => `
  // 			${slideTrans.css(t)}
  // 			opacity: ${mapRange(t, 0.8, 1, 0, 1)};
  // 		`,
  //   }
  // }

  // function mapRange(current, in_min, in_max, out_min, out_max) {
  //   const mapped = ((current - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
  //   return clamp(mapped, out_min, out_max)
  // }
</script>

<!-- <Intersection let:visible> -->
<div class="messages" aria-hidden="true" class:intro={messages.length > 1}>
  {#each mappedMessages as { text, visible, animating }, i}
    {@const right = i % 2}
    {@const left = !right}
    {@const messageVisible = visible & !animating}
    {#if animating}
      <div class="message dots" class:left class:right class:visible>
        <div class="spinner">
          <div class="dot" />
          <div class="dot" />
          <div class="dot" />
        </div>
      </div>
    {/if}
    <div class="message" class:left class:right class:visible={messageVisible}>
      <div class="text">{text}</div>
    </div>
  {/each}
</div>
<div
  class="nrk-sr"
  role="img"
  aria-label={`Meldingsdialog med to deltakere. Avsender 1: ${messages[0]}. Avsender 2: ${messages[1]}`}
/>

<!-- </Intersection> -->

<style>
  .intro {
    margin-top: 20vh;
    @media (height >= 1200px) {
      margin-top: 30vh;
    }
  }
  .messages {
    position: relative;
  }

  .text {
    max-width: 280px;
  }

  .message {
    border-radius: 15px;
    width: fit-content;
    padding: 15px;
    font-size: 1rem;
    font-weight: var(--nrk-sans-weight-medium);
    color: var(--dhsa-color-background-primary);
    background-color: var(--dhsa-color-accent-primary);
    margin-bottom: 48px;
    opacity: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .message.left {
    margin-right: auto;
  }

  .message.right {
    margin-left: auto;
    background-color: var(--dhsa-color-background-tertiary);
    color: var(--dhsa-color-text-primary);
  }

  .message.dots {
    position: absolute;
    inset-inline: 0;
  }

  .visible {
    opacity: 1;
    transition: 0.2s;
  }

  .message.left .dot {
    background-color: #825a5c;
    animation-name: spinner-alt;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #3d5e89;
    display: inline-block;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-duration: 1s;
    animation-name: spinner;
  }
  .dot:nth-child(1) {
    animation-delay: 0s;
  }
  .dot:nth-child(2) {
    animation-delay: 0.5s;
  }
  .dot:nth-child(3) {
    animation-delay: 1s;
  }

  @keyframes spinner {
    0% {
      background-color: #ced7e2;
    }
    50%,
    100% {
      background-color: #3d5e89;
    }
  }
  @keyframes spinner-alt {
    0% {
      background-color: #0a2343;
    }
    50%,
    100% {
      background-color: #825a5c;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .message {
      animation-delay: 0ms !important;
      animation-duration: 1ms !important;
    }
  }
</style>
